import React, { useState, useEffect, useRef } from "react"
import { Typography, TextField, InputAdornment, Fab } from '@mui/material'
import { Container, DropzoneContainer, Input } from "./styles"
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

const FileDropzone: React.FC<{ nfeFile: File | null, setNFeFile: React.Dispatch<React.SetStateAction<File | null>>, required: boolean, form: string }>
    = ({ nfeFile, setNFeFile, required = false, form }) => {

        const [enderecoArquivo, setEnderecoArquivo] = useState<string>('')

        const inputFile = useRef<HTMLInputElement | null>(null)

        const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();

            const file = Array.from(event.dataTransfer.files)[0];
            if (file)
                setNFeFile(file)
        }

        const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
            const file = Array.from(event.target.files || [])[0]
            if (file)
                setNFeFile(file)
        }

        const onButtonClick = () => {
            if (inputFile && inputFile.current)
                inputFile.current.click()
        }

        useEffect(() => {

            if (nfeFile)
                setEnderecoArquivo(nfeFile.name)
        }, [nfeFile])

        return (
            <Container>
                <DropzoneContainer
                    onDrop={handleDrop}
                    onDragOver={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    onClick={onButtonClick}
                >
                    <FileUploadIcon />
                    <Input
                        type="file"
                        onChange={handleFileSelect}
                        ref={inputFile}
                        multiple
                        required={required}
                        form={form}
                    />
                    <Typography variant="body1">
                        Arraste e solte a nota fiscal ou clique para selecionar uma
                    </Typography>
                </DropzoneContainer>
                <TextField
                    id="input-with-icon-textfield"
                    disabled
                    value={enderecoArquivo}
                    fullWidth={true}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <FolderOpenIcon />
                            </InputAdornment>
                        ),
                    }}
                    variant="standard"
                />
            </Container>
        );
    };

export default FileDropzone;
